import { apiClient } from 'pobble-components/dist/api'

export const apiGetFeedItems = params =>
  apiClient.get('/v3/me/pa_action_feed_items', { params })

export const apiGetFeedItem = (id, params) =>
  apiClient.get(`/v3/pa_action_feed_items/${id}`, { params })

export const apiRejectWork = (workVersionId, data) =>
  apiClient.put(`/v3/pa_work_versions/${workVersionId}/reject`, data)

export const apiApproveWork = (workVersionId, data) =>
  apiClient.put(`/v3/pa_work_versions/${workVersionId}/approve`, data)

export const apiGetStudentsPerSession = (sessionId, params) =>
  apiClient.get(`/v3/pa_sessions/${sessionId}/students_data`, { params })

export const apiCreateWork = (studentId, data, params) => {
  const formData = new FormData()
  Object.keys(data).forEach(key => formData.append(key, data[key]))
  return apiClient.post(`/v3/students/${studentId}/works`, formData, { params })
}

export const apiGetPresentationAction = params =>
  apiClient.get(`/v3/pa_presentation_actions/current`, { params })

export const apiAddStudentsToSession = (sessionId, data, params) =>
  apiClient.post(`/v3/pa_sessions/${sessionId}/add_students`, data, { params })
